import { createAsyncThunk } from '@reduxjs/toolkit';
import * as API from './apis';
import Swal from 'sweetalert2';

export const getAllDrawers = createAsyncThunk(
  'Drawers/getAllDrawers',
  async ({ filter, pagination }: any) => {
    try {
      const res: any = await API.getAllDrawers({ filter, pagination });
      return res.data;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al cargar los datos',
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);

export const updateDrawer = createAsyncThunk(
  'Drawers/updateDrawer',
  async ({ values, text }: any) => {
    try {
      const res = await API.updateDrawer(values);
      Swal.fire({
        icon: 'success',
        title: `${text || 'Editado'} con exito`,
      });
      return res;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: `Hubo un error al editar los datos`,
        text: 'intenta de nuevo',
      });
      throw error;
    }
  }
);

export const createDrawer = createAsyncThunk(
  'Drawers/createDrawer',
  async (drawer: any) => {
    try {
      const res = await API.createDrawer(drawer);
      if (res.status === 200) {
        Swal.fire('Correcto', 'El almacen se agregó correctamente', 'success');
        return true;
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Hubo un error al crear el almacen',
        text: 'Por favor, intenta de nuevo',
      });
      throw error;
    }
  }
);
